export const LOW_CREDIT_THRESHOLD = 15;
